import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';

import * as _ from 'underscore';

// Service
import { AttachmentListService } from '../../service/attachment-list/attachment-list.service';
import { DocumentType } from '../../../models/document-type';

@Component({
  selector: 'app-attachment-list',
  templateUrl: './attachment-list.component.html',
  providers: [
    AttachmentListService,
    HttpModule
  ]
})
export class AttachmentListComponent implements OnInit {

  private token;
  public orderby: string = "Descricao";
  public sort: string = "asc";
  public attachments: any[] = [];
  public permissoes: any[] = [];
  public documentTypes: DocumentType;
  public resultCount: number = 0;
  attachment: FormGroup;
  currentPage: number = 0;
  isDesc: boolean = false;
  column: string = 'CategoriaDescricao';

  constructor(fb: FormBuilder, private attachmentListService: AttachmentListService, private flashMessagesService: FlashMessagesService, private router: Router) {
    this.token = localStorage.getItem('yara.token');
    this.documentTypes = new DocumentType();
    this.attachment = fb.group({
      'Descricao': '',
      'CategoriaDocumento': '',
      'Ativo': ''
    });
  }

  ngOnInit() {
    this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
    this.searchAttachment(this.attachment.value, 0, false);
  }

  paginar($event: any) {
    this.currentPage = $event;
    this.searchAttachment(this.attachment.value, $event, false);
  }

  searchAttachment(value: any, page, isSearch) {
		if (isSearch) {
			this.orderby = "Descricao";
			this.sort = "asc";
			this.currentPage = 0;
    }

		this.attachmentListService.searchAttachment(this.token, value.Descricao, value.Ativo, this.orderby, this.sort, page).subscribe(result => {
			if (result.Success) {
				this.attachments = result.Result;

        this.attachments = this.attachments.map(attachment =>({
          ...attachment, 
          CategoriaDocumentoDescricao: this.documentTypes.getDescricao(attachment.CategoriaDocumento)}))

				this.resultCount = result.Count;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		})
	}

  setOrder(property){
		this.isDesc = !this.isDesc; //change the direction    
		this.column = property;
		let direction = this.isDesc ? 1 : -1;
	
		this.attachments.sort(function(a, b){

			if (a[property] < b[property]) {
				return -1 * direction;
			}
			else if (a[property] > b[property]) {
				return 1 * direction;
			}
			else{
				return 0;
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/attachment/component/attachment-list/attachment-list.component.ts